import { FC, ReactNode } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";
import { FullBleedSection } from "~/components";

interface Props extends FlexProps {
  children: ReactNode;
}
export const QuestionPageContainer: FC<Props> = ({ children, ...props }) => (
  <FullBleedSection bg="bg-main" flexGrow={1} h="100%" justify="flex-start">
    <Flex
      direction="column"
      flexGrow={1}
      gap={14}
      maxWidth="39rem"
      mb={8}
      px={{ base: 4, md: 8 }}
      pt={{ base: 10, md: 16 }}
      pb={{ base: "15rem" }}
      w="full"
      {...props}
    >
      {children}
    </Flex>
  </FullBleedSection>
);
